import axios from "./axios";

export async function deleteOfferCalculation(payload) {
  return axios
    .delete(`/offer_calculations/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createOfferCalculation(payload) {
  return axios
    .post(`/offer_calculations/`, { offer_calculation: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function updateOfferCalculation(payload) {
  return axios
    .put(`/offer_calculations/` + payload.id, { offer_calculation: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.status !== 200) return error;
      else return error.response;
    });
}

export async function fetchOfferCalculation(payload) {
  // payload is only ID
  return axios
    .get(`/offer_calculations/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchOfferCalculations(controller) {
  return axios({ method: "get", url: "/offer_calculations", params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}



